import { Navigate, Route, Routes, } from "react-router-dom";
import { routes } from "./RoutePath";

const AllRoutes = () => {
  return (
    <>
      <Routes>
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={<route.component />}
            ></Route>
          );
        })}
        <Route path="/" element={<Navigate to="/dashBoard" />} />
      </Routes>
    </>
  );
};

export default AllRoutes;
